'use strict';

angular.module('licensure.services')
    .factory('AutoNumbers', ['$http', '$q', function ($http, $q) {
        return {
            get: function (licenseID, licenseCategoryID) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/autonumbers', {
                        params: {
                            licenseID: licenseID,
                            licenseCategoryID: licenseCategoryID
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/autonumbers/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.reject(response.data);
                    });

                return d.promise;
            }
        }
    }])
;